import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const telehealthAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.TELEHEALTH_BASE_URL as string,
});

setupInterceptors(telehealthAxiosInstance);

export default telehealthAxiosInstance;
